import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const GalleryView = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M4 7.20006C4 6.07996 4 5.5199 4.21799 5.09208C4.40973 4.71576 4.71569 4.40979 5.09202 4.21805C5.51984 4.00006 6.0799 4.00006 7.2 4.00006H10V10.0001H4V7.20006Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14 4.00006H16.8C17.9201 4.00006 18.4802 4.00006 18.908 4.21805C19.2843 4.40979 19.5903 4.71576 19.782 5.09208C20 5.5199 20 6.07996 20 7.20006V10.0001H14V4.00006Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4 14.0001H7H10V20.0001H7.2C6.0799 20.0001 5.51984 20.0001 5.09202 19.7821C4.71569 19.5903 4.40973 19.2844 4.21799 18.908C4 18.4802 4 17.9202 4 16.8001V14.0001Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14 14.0001H20V16.8001C20 17.9202 20 18.4802 19.782 18.908C19.5903 19.2844 19.2843 19.5903 18.908 19.7821C18.4802 20.0001 17.9201 20.0001 16.8 20.0001H14V14.0001Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M10 3.25H7.16957C6.63542 3.24999 6.18956 3.24998 5.82533 3.27974C5.44545 3.31078 5.08879 3.37789 4.75153 3.54973C4.23408 3.81338 3.81338 4.23408 3.54973 4.75153C3.37789 5.08879 3.31078 5.44545 3.27974 5.82533C3.24998 6.18956 3.24999 6.63541 3.25 7.16956V10C3.25 10.4142 3.58579 10.75 4 10.75H10C10.4142 10.75 10.75 10.4142 10.75 10V4C10.75 3.58579 10.4142 3.25 10 3.25Z'
          fill='currentColor'
        />
        <path
          d='M19.2485 3.54973C18.9112 3.37789 18.5546 3.31078 18.1747 3.27974C17.8104 3.24998 17.3646 3.24999 16.8304 3.25H14C13.5858 3.25 13.25 3.58579 13.25 4V10C13.25 10.4142 13.5858 10.75 14 10.75H20C20.4142 10.75 20.75 10.4142 20.75 10V7.16955C20.75 6.6354 20.75 6.18956 20.7203 5.82533C20.6892 5.44545 20.6221 5.08879 20.4503 4.75153C20.1866 4.23408 19.7659 3.81338 19.2485 3.54973Z'
          fill='currentColor'
        />
        <path
          d='M4 13.25C3.58579 13.25 3.25 13.5858 3.25 14V16.8304C3.24999 17.3646 3.24998 17.8104 3.27974 18.1747C3.31078 18.5546 3.37789 18.9112 3.54973 19.2485C3.81338 19.7659 4.23408 20.1866 4.75153 20.4503C5.08879 20.6221 5.44545 20.6892 5.82533 20.7203C6.18956 20.75 6.6354 20.75 7.16955 20.75H10C10.4142 20.75 10.75 20.4142 10.75 20V14C10.75 13.5858 10.4142 13.25 10 13.25H4Z'
          fill='currentColor'
        />
        <path
          d='M14 13.25C13.5858 13.25 13.25 13.5858 13.25 14V20C13.25 20.4142 13.5858 20.75 14 20.75H16.8305C17.3646 20.75 17.8104 20.75 18.1747 20.7203C18.5546 20.6892 18.9112 20.6221 19.2485 20.4503C19.7659 20.1866 20.1866 19.7659 20.4503 19.2485C20.6221 18.9112 20.6892 18.5546 20.7203 18.1747C20.75 17.8104 20.75 17.3646 20.75 16.8305V14C20.75 13.5858 20.4142 13.25 20 13.25H14Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
